import Component from "./Settings";
export default Component;